<template>
  <div class="main-content">
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body d-flex align-items-center justify-content-between py-2">
            <h4 class="mb-0">
              <i class="fas fa-exclamation-circle text-primary mr-2"></i>
              Tipos de Intercorrência
            </h4>
            <button class="btn btn-primary btn-sm" @click="openModal()">
              <i class="fas fa-plus mr-1"></i> Novo Tipo
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body p-0">
            <div v-if="loading" class="text-center py-5">
              <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
            </div>
            <div v-else-if="types.length === 0" class="text-center py-5 text-muted">
              <p class="mb-0">Nenhum tipo cadastrado.</p>
            </div>
            <table v-else class="table table-hover table-bordered mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Nome</th>
                  <th>Descrição</th>
                  <th class="text-center" style="width: 100px">Ativo</th>
                  <th class="text-center" style="width: 100px">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="type in types" :key="type.id">
                  <td><strong>{{ type.name }}</strong></td>
                  <td>{{ type.description || '—' }}</td>
                  <td class="text-center">
                    <span :class="type.active ? 'badge badge-success' : 'badge badge-secondary'">
                      {{ type.active ? 'Sim' : 'Não' }}
                    </span>
                  </td>
                  <td class="text-center">
                    <button class="btn btn-sm btn-crud edit mr-1" title="Editar" @click="openModal(type)">
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                    <button class="btn btn-sm btn-crud delete" title="Excluir" @click="destroy(type)">
                      <i class="far fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="modal-backdrop-custom" @click.self="closeModal">
      <div class="modal-dialog-custom">
        <div class="card mb-0">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{ form.id ? 'Editar Tipo' : 'Novo Tipo' }}</h5>
            <button type="button" class="btn btn-sm btn-light" @click="closeModal">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label>Nome <span class="required">*</span></label>
              <input v-model="form.name" type="text" class="form-control" placeholder="Nome do tipo" />
            </div>
            <div class="form-group">
              <label>Descrição</label>
              <input v-model="form.description" type="text" class="form-control" placeholder="Descrição opcional" />
            </div>
            <div class="form-group">
              <label class="d-flex align-items-center" style="gap: 8px">
                <input type="checkbox" v-model="form.active" />
                Ativo
              </label>
            </div>
          </div>
          <div class="card-footer d-flex justify-content-end">
            <button class="btn btn-secondary mr-2" @click="closeModal">Cancelar</button>
            <button class="btn btn-primary" :disabled="saving" @click="save">
              <i v-if="saving" class="fas fa-spinner fa-spin mr-1"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      types: [],
      loading: true,
      showModal: false,
      saving: false,
      form: { id: null, name: '', description: '', active: true },
    };
  },

  mounted() {
    if (this.$store.state.user.perfil_id !== 8) {
      this.$router.replace('/');
      return;
    }
    this.fetchTypes();
  },

  methods: {
    fetchTypes() {
      this.loading = true;
      axios
        .get(this.$store.state.api + 'occurrence-types')
        .then(res => { this.types = res.data.data || res.data; })
        .catch(() => { this.$message('Erro', 'Não foi possível carregar os tipos.', 'error'); })
        .finally(() => { this.loading = false; });
    },

    openModal(type = null) {
      this.form = type
        ? { id: type.id, name: type.name, description: type.description || '', active: type.active }
        : { id: null, name: '', description: '', active: true };
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    save() {
      if (!this.form.name.trim()) {
        this.$message('Atenção', 'O nome é obrigatório.', 'warning');
        return;
      }
      this.saving = true;
      const req = this.form.id
        ? axios.put(this.$store.state.api + `occurrence-types/${this.form.id}`, this.form)
        : axios.post(this.$store.state.api + 'occurrence-types', this.form);

      req
        .then(() => {
          this.$message('Sucesso', 'Tipo salvo com sucesso!', 'success');
          this.closeModal();
          this.fetchTypes();
        })
        .catch(() => { this.$message('Erro', 'Não foi possível salvar o tipo.', 'error'); })
        .finally(() => { this.saving = false; });
    },

    destroy(type) {
      swal({
        title: 'Deseja excluir este tipo?',
        text: 'Essa operação não pode ser desfeita.',
        type: 'warning',
        buttons: {
          cancel: { text: 'Não', value: 'cancel', className: 'btn-danger' },
          confirm: { text: 'Sim', value: 'confirm' },
        },
      }).then(value => {
        if (value === 'confirm') {
          axios
            .delete(this.$store.state.api + `occurrence-types/${type.id}`)
            .then(() => { this.$message('Sucesso', 'Tipo excluído!', 'success'); this.fetchTypes(); })
            .catch(() => { this.$message('Erro', 'Não foi possível excluir.', 'error'); });
        }
      });
    },
  },
};
</script>

<style scoped>
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-dialog-custom {
  width: 100%;
  max-width: 480px;
  padding: 0 16px;
}
</style>
